// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
//import ButtonBase from '@material-ui/core/ButtonBase';
//import { 
		//useHistory, 
//		useParams 
//} from 'react-router-dom';
//import PropTypes from 'prop-types';
//import AppBar from '@material-ui/core/AppBar';
//import Tabs from '@material-ui/core/Tabs';
//import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';

//import Map from './Map';
import Map from '../map/Map';
import Gps from '../map/Gps';
//import SingleMap from '../map/SingleMap';
//import ConfigStandard from '../configuration/standard/Config';
import Option from './option/View';
import History from './services/History';
import AdvanceWarning from './services/AdvanceWarning';
import UpdateDetails from './services/UpdateDetails';
import UpdateLog from './services/UpdateLog';
import UpdateErrors from './services/UpdateErrors';
//import SignDetails from './Details';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signType : {
	 // backgroundImage:'url(uploaded/file_17_vcalmVMS.png)', //'url('+sign.sign_type_obj.path+')', 
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
	 // direction:'row',
	 // alignItems:'flex-end'
	  //verticalAlign:'bottom',
	  //textAlign:'center',
	  //display:'table-cell',
	  //flexGrow: 1,
	  //display: 'table-cell'
  },
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},
  signTypeText : {
	  alignSelf: 'flex-end'
  },
  center: {
	textAlign: 'center'
  },
  image: {
    width: 128,
    height: 128,
  },
  break: {
	  height:20
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));




export default function SignOverview(props) {
	const classes = useStyles();
	const {handleSend, user, sign, onChange, handleSave} = props;
	const [loaded, setLoaded] = React.useState(false);
	const [geoloc, setGeoloc] = React.useState('-117.8027955, 33.86.25262');
	const [address, setAddress] = React.useState('');
	//const [loadedServices, setLoadedServices] = React.useState(false);
	const [services, setServices] = React.useState({});
	const [servicesLoaded, setServicesLoaded] = React.useState(false);
  	//const [force, setForce] = React.useState(false);
	const [signId, setSignId] = React.useState(0);
  	const [mySign, setMySign] = React.useState({
		sign_type_obj:{},
		options:[],
		geo_location: '-117.8027955, 33.86.25262',
	});
   	React.useEffect(() => {
		//console.log('overview effect');
		//console.log('Loaded: ' + loaded);
		//console.log('SignId: ' + signId);
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			setMySign(sign);
			if(sign.geo_location){
				setGeoloc(sign.geo_location);
			}
			if(sign.address){
				setAddress(sign.address);
			}
			//console.log(sign.sign_type_obj);
		}
		if(!loaded && signId){
			getServices();
		} 
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sign, loaded, signId]);
	React.useEffect(() => {
		handleUpdateValues({
			geo_location: geoloc,
			address: address
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [geoloc, address])
 	const getServices = () => {
		//console.log('loading services');
	  	setLoaded(true);
	  	handleSend({
		  	vso: 'services',
		  	sign: signId
	  	}, (data) => {
			setServices(data.services);
			setServicesLoaded(true);
		});
	}

	const handleUpdateValues = (newvals) => {
		//only update if current data is present
		var newSign = Object.assign({}, mySign);
		if(newSign.id){
			setMySign(newSign);
			//setForce(false);
		} else {
			console.log('did not update');
		}
	}
	/*
	const handleDragPointer = (geoloc, address) =>{
		console.log(geoloc);
		console.log(address);
		setGeoloc(geoloc);
		setAddress(address);
		//handleUpdateValues({
		//	geo_location: geoloc,
		//	address: address
		//});
	}
	*/
	const compileUpdateDetails = () => {
		if(services.update_details){
			return (
			<Grid item sm={12} md={6} lg={4}>
				<UpdateDetails items={services.update_details} sign={sign} handleSave={handleSave} updateSign={onChange} />
	  		</Grid>
				);
		}
		return '';
	}
	const compileUpdateLog = () => {
		if(services.update_log){
			return (
			<Grid item sm={12} md={6} lg={4}>
	  	  	 	<Typography>Update Log</Typography>
				<UpdateLog items={services.update_log} />
	  		</Grid>
				);
		}
		return '';
	}
	const compileUpdateErrors = () => {
		if(services.update_errors && (parseInt(user.usergroup) === 1 || user.edit_function === 1)  //Check usergroup when implemented
		  ){
			return (
			<Grid item sm={12} md={6} lg={4}>
	  	  	 	<Typography>Update Errors</Typography>
				<UpdateErrors items={services.update_errors} />
	  		</Grid>
				);
		}
		return '';
	}
	const compileMaintenanceLog = () => {
		if(services.maintenance_log){
			return (
			<Grid item sm={12} md={6} lg={4}>
	  	  	 	<Paper className={classes.paper}>
	  				<Typography variant="h3" gutterBottom>Maintenance Log</Typography>
				</Paper>
	  		</Grid>
				);
		}
		return '';
	}
	const compileAnalogDetails = () => {
		if(services.analog_details){
			return (
			<Grid item sm={12} md={6} lg={4}>
	  	  	 	<Paper className={classes.paper}>
	  				<Typography variant="h3" gutterBottom>Analog Details</Typography>
				</Paper>
	  		</Grid>
				);
		}
		return '';
	}
	//<Paper className={classes.paper}>
	//<Typography variant="h3" gutterBottom>GPS</Typography>
	//</Paper>
	const compileGps = () => {
		if(services.gps){
			return (
			<Grid item sm={12} md={6} lg={4}>
				<Typography>GPS History</Typography>
				<Gps locations = {services.gps.slice().reverse()} />
	  		</Grid>
				);
		}
		return '';
	}
	const compileEco = () => {
		if(services.eco){
			return (
			<Grid item sm={12} md={6} lg={4}>
	  	  	 	<Paper className={classes.paper}>
	  				<Typography variant="h3" gutterBottom>ECO Data</Typography>
				</Paper>
	  		</Grid>
				);
		}
		return '';
	}
	const compileAdvWarning = () => {
		if(services.adv_warning){
			return (
			<Grid item sm={12} md={6} lg={4}>
				<Typography>Advance Warning</Typography>
				<AdvanceWarning items={services.adv_warning} />
	  		</Grid>
				);
		}
		return '';
	}
	const compileHistory = () => {
		if(services.history){
			return (
			<Grid item sm={12} md={12} xl={6}>
				<Typography>History</Typography>
				<History items={services.history} />
	  		</Grid>
				);
		}
		return '';
	}
	const compileRegistration = () => {
		if(services.registration){
			return (
			<Grid item sm={12} md={6} lg={4}>
	  	  	 	<Paper className={classes.paper}>
	  				<Typography variant="h3" gutterBottom>Registration</Typography>
				</Paper>
	  		</Grid>
				);
		}
		return '';
	}

	const placeholder = () => {
		if(servicesLoaded) return '';
		return (
			<Grid container spacing={2}>
					<Grid item sm={12} md={6} lg={4}><Skeleton height={300} variant='rect' /></Grid>
					<Grid item sm={12} md={6} lg={4}><Skeleton height={300} variant='rect' /></Grid>
					<Grid item sm={12} md={12} xl={6}><Skeleton height={300} variant='rect' /></Grid>
					<Grid item sm={12} md={12} xl={6}><Skeleton height={300} variant='rect' /></Grid>
			</Grid>
		);
	}
	//console.log(mySign.sign_type_obj)
	

	return (
		<div className={classes.root}>
			<Paper className={classes.paper} component="div">
				<Grid container spacing={3}>
					<Grid item xs={12} sm={4}>
						<Typography variant="h5" gutterBottom>
							{mySign.location}
	  					</Typography>
	  					<Typography variant="body2" gutterBottom>
	  		  	  			{mySign.description}
	  					</Typography>
	  					<Typography variant="body2" color="textSecondary">
	  		  	  			{address}
	  					</Typography>
						<Box className={classes.advancedCard}>
							<Box className={classes.advancedContent}>
								{mySign.options.map((opt) => (
						 		<Option id={opt.id} path={opt.path} name={opt.name} key={opt.id} />
								))}
							</Box>
						</Box>
	  	  	  		</Grid>
	  	  	  		<Grid item xs={12} sm={4} className={classes.signType}
						container
						direction="row"
						alignItems="flex-end"
						justifyContent="center"
						style={{
							backgroundImage:'url("http://forteltraffic.com/'+encodeURI(mySign.sign_type_obj.path)+'")'
						}}>
	  		  	  		<Typography>{mySign.sign_type_obj.name}</Typography>
	  	  	  		</Grid>
	  	  	  		<Grid item xs={12} sm={4}>
						<Map signs={[mySign]} />
	      	  		</Grid>
	    		</Grid>
	  	  	</Paper>
			<div className={classes.break} />
			{placeholder()}
	  	  	<Grid container spacing={3}>
				{compileUpdateDetails()}
				{compileUpdateLog()}
				{compileUpdateErrors()}
				{compileMaintenanceLog()}
				{compileAnalogDetails()}
				{compileGps()}
				{compileEco()}
				{compileAdvWarning()}
				{compileHistory()}
				{compileRegistration()}
	  	  	</Grid>
		</div>
	);
}
